module.exports = __webpack_public_path__ + "static/media/actualizacion.5a605557.svg";